var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 14.375V25.625C30.125 29 28.4375 31.25 24.5 31.25H15.5C11.5625 31.25 9.875 29 9.875 25.625V14.375C9.875 11 11.5625 8.75 15.5 8.75H24.5C28.4375 8.75 30.125 11 30.125 14.375Z",
    stroke: "#0001a5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8125 11.5625V13.8125C22.8143 14.4087 23.0519 14.98 23.4735 15.4015C23.895 15.8231 24.4663 16.0607 25.0625 16.0625H27.3125",
    stroke: "#0001a5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21.125H20",
    stroke: "#0001a5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.625H24.5",
    stroke: "#0001a5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPp);
export default __webpack_public_path__ + "static/media/p&p.c80bd4fa.svg";
export { ForwardRef as ReactComponent };